module.exports = __webpack_public_path__ + "img/yiwu.d11abb76.png";